import styled from '@mui/material/styles/styled';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';

export const PrimaryLightInput = styled(TextField)(({ theme }) => `
    background-color: ${theme.palette.primary.light};
    color: #FFFFFF !important;
    font-family: Roboto-Medium;
    border-radius: 8px;
    :hover{
        cursor: pointer
    }
    :placeholder{
        color: #FFF !important
    }
`)

export const PrimaryLightSelect = styled(Select)(({ theme }) => `
    background-color: ${theme.palette.primary.light};
    color: #FFFFFF !important;
    font-family: Roboto-Medium;
    border-radius: 8px;
    
    :placeholder{
        color: #FFF !important
    }
`)